import { Text } from '@chakra-ui/react';
import { formatPrice, getPriceInCurrency } from '@jurnee/common/src/utils/prices';
import { Trans, useTranslation } from 'react-i18next';
import { ProductJSON } from '../../../../entities/Product';
import { CurrencyConversion } from '../../../../utils/currencies';
import { getMaxThreshold, getProductPrice, isCustomRequestProduct, isParticipantsRangeValid } from '../../../../utils/products';

interface Props {
  product: ProductJSON;
  participants: number;
  currencyConversion?: Omit<CurrencyConversion, 'source'>;
}

export function PriceLine({ product, participants, currencyConversion }: Props) {
  const { t } = useTranslation('common');

  if (!isParticipantsRangeValid(product, participants)) {
    return (
      <Text lineHeight="26px" color="red.500">
        <Trans
          i18nKey='experience:form.steps.information.participants.error'
          values={{ min: 1, max: getMaxThreshold(product) }}
        />
      </Text>
    );
  }

  if (isCustomRequestProduct(product)) {
    return null;
  }

  const productPrice = getProductPrice(product, participants);

  if (productPrice === null) {
    return null;
  }

  const { value, currency } = currencyConversion
    ? {
      value: getPriceInCurrency(productPrice, { ...currencyConversion, source: product.currency }).value,
      currency: currencyConversion.target
    }
    : {
      value: productPrice,
      currency: product.currency
    };

  return (
    <>
      <Text fontSize={20} fontWeight={700}>
        { formatPrice(value, currency) }
      </Text>

      <Text lineHeight="24px" color="gray.400" h={5}>
        { t('excludedTax') }
      </Text>
    </>
  );
}